import React from 'react';
import MaterialTableHead, {
    TableHeadProps as MaterialTableHeadProps,
} from '@mui/material/TableHead';
import styled from 'styled-components';

const StyledTableHead = styled(MaterialTableHead)`
    background-color: rgba(17, 17, 17, 0.05);
    th,
    td {
        padding: 0.5rem 1rem;
        font-size: 0.75rem;
        color: #111111;
        text-transform: uppercase;
        font-weight: bold;
    }
`;
export interface TableHeadProps extends MaterialTableHeadProps {}

const TableHead: React.FunctionComponent<TableHeadProps> = ({ children, ...props }) => {
    return <StyledTableHead {...props}>{children}</StyledTableHead>;
};

export default TableHead;
